import { useState } from 'react';
import BaseButton from 'components/atoms/baseButton';
import { useGetCallRecordLink } from 'infrastructure/hooks/calls/use-get-call-record-link';
import { useTranslation } from 'react-i18next';
import { PlayIcon } from 'components/atoms/icons/audioPlayer/play';
import CallAudioPlayerModal from 'components/organisms/call-audio-player/modal';
import { useGetCallTranscribe } from 'infrastructure/hooks/calls/use-get-call-transcribe';

import type { CallRecordLinkProps } from 'infrastructure/hooks/calls/use-get-call-record-link/types';
import type { FC } from 'react';

const PlayCallRecord: FC<CallRecordLinkProps> = (props) => {
  const { callId, patientPhone, patientName } = props;
  const [audioUrl, setAudioUrl] = useState<string | null>(null);
  const [showTranscript, setShowTranscript] = useState(false);
  const { t } = useTranslation();

  const { getCallRecordLink, getCallRecordLinkLoading } =
    useGetCallRecordLink();

  const handleDownload = async () => {
    const url = await getCallRecordLink(props);
    if (url) {
      setAudioUrl(url);
    }
  };

  const { getCallTranscribeLoading, transcripts, callTranscribeErrorMessage } =
    useGetCallTranscribe({
      ...props,
      enabled: showTranscript,
    });

  return (
    <div>
      {audioUrl && (
        <CallAudioPlayerModal
          patientPhone={patientPhone}
          patientName={patientName}
          callId={callId}
          audioUrl={audioUrl}
          isOpen
          close={() => {
            setAudioUrl(null);
          }}
          transcripts={transcripts}
          transcriptsLoading={getCallTranscribeLoading}
          showTranscript={showTranscript}
          toggleShowTranscript={() => setShowTranscript(!showTranscript)}
          callTranscribeErrorMessage={callTranscribeErrorMessage}
        />
      )}
      <BaseButton
        icon={<PlayIcon />}
        label={audioUrl ? t('controls.playing') : t('controls.play')}
        onClick={handleDownload}
        type="secondary"
        loading={getCallRecordLinkLoading}
        disabled={!!audioUrl}
      />
    </div>
  );
};

export default PlayCallRecord;
